import { Box, MenuItem, Typography } from "@mui/material"
import type { FC } from "react"
import React from "react"
import { Controller, useFormContext } from "react-hook-form"

import MultiSelect from "@/components/MultiSelect/MultiSelect"
import { FIELD_ERROR_CLASSES } from "@/constants/forms"
import type { SelectOption } from "@/types/form-fields"

interface CompanyInfoSelectProps {
  name: string
  title?: string
  isEditMode: boolean
  options: SelectOption[]
}

const CompanyInfoSelect: FC<CompanyInfoSelectProps> = ({ name, title, options, isEditMode }) => {
  const { control } = useFormContext()

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <Box className='relative'>
          {title && (
            <Typography variant='subtitle1' className='mb-4 mt-6 text-ml text-gray-900'>
              {title}
            </Typography>
          )}

          <MultiSelect
            id={field.name + "Select"}
            name={field.name}
            disabled={!isEditMode}
            value={field.value}
            onChange={field.onChange}
            options={options}
            error={!!error}
          >
            {options.map(({ value, label }) => (
              <MenuItem key={field.name + value} value={value} className='pl-8'>
                {label}
              </MenuItem>
            ))}
          </MultiSelect>

          {error?.message && <p className={FIELD_ERROR_CLASSES}>{error.message}</p>}
        </Box>
      )}
    />
  )
}

export default CompanyInfoSelect
